<template>
  <div class="container mx-auto flex flex-col">
    <div class="app-content-back">
      <div class="page-title font-xl mb-4">
        Tricks & Mastery
      </div>

      <input
        v-model="searchTerm"
        type="text"
        placeholder="Filtern"
        class="ml-2 mb-4 flex-grow bg-gray-200 appearance-none border-2 border-green-200 rounded w-64 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-500"
        @change="searchChanged()"
        @keyup.enter="searchChanged()"
      >
      <contentConsent consent-name="Funktionale" v-if="!functionalAllowed" />
      <div>
        <div class="section-title">
          Level 1
        </div>
        <div class="flex flex-row flex-wrap p-8">
          <div
            v-for="item in level1"
            :key="item.id"
          >
            <router-link :to="{name: 'masteries.detail', params: { id: item.id} }">
              <sc-mastery-small
                :title="item.name"
                :links="item.links"
                :difficulty="item.difficulty"
                :image="item.previewImage"
              />
            </router-link>
          </div>
        </div>

        <div class="section-title">
          Level 2
        </div>
        <div class="flex flex-row flex-wrap p-8">
          <div
            v-for="item in level2"
            :key="item.id"
          >
            <router-link :to="{name: 'masteries.detail', params: { id: item.id} }">
              <sc-mastery-small
                :title="item.name"
                :links="item.links"
                :difficulty="item.difficulty"
                :image="item.previewImage"
              />
            </router-link>
          </div>
        </div>

        <div class="section-title">
          Level 3
        </div>
        <div class="flex flex-row flex-wrap p-8">
          <div
            v-for="item in level3"
            :key="item.id"
          >
            <router-link :to="{name: 'masteries.detail', params: { id: item.id} }">
              <sc-mastery-small
                :title="item.name"
                :links="item.links"
                :difficulty="item.difficulty"
                :image="item.previewImage"
              />
            </router-link>
          </div>
        </div>

        <div class="section-title">
          Level 4
        </div>
        <div class="flex flex-row flex-wrap p-8">
          <div
            v-for="item in level4"
            :key="item.id"
          >
            <router-link :to="{name: 'masteries.detail', params: { id: item.id} }">
              <sc-mastery-small
                :title="item.name"
                :links="item.links"
                :difficulty="item.difficulty"
                :image="item.previewImage"
              />
            </router-link>
          </div>
        </div>
        <div class="section-title">
          Level 5
        </div>
        <div class="flex flex-row flex-wrap p-8">
          <div
            v-for="item in level5"
            :key="item.id"
          >
            <router-link :to="{name: 'masteries.detail', params: { id: item.id} }">
              <sc-mastery-small
                :title="item.name"
                :links="item.links"
                :mediaConsent="functionalAllowed"
                :difficulty="item.difficulty"
                :image="item.previewImage"
              />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'
import contentConsent from '@/components/cookies/contentConsent'

export default {
    name: 'MasteriesList',
  components: { contentConsent },
    data () {
        return {
            searchTerm: '',
            level1: [],
            level2: [],
            level3: [],
            level4: [],
            level5: [],
            isBusy: false,
            items: [],
            functionalAllowed: false
        }
    },
    async mounted () {
        const cookie = this.$cookies.get('cookiefirst-consent')
        const functional = cookie && cookie.functional
        this.functionalAllowed = functional
        await this.readAll()
    },
    methods: {

        searchChanged () {
            this.resolveItems()
        },
        resolveItems () {
            var temp = this.items
            if (this.searchTerm && this.searchTerm.length > 0) {
                temp = temp.filter(x => x.name.toLowerCase().includes(this.searchTerm.toLowerCase()))
            }
            this.level1 = temp.filter(x => x.difficulty === 1)
            this.level2 = temp.filter(x => x.difficulty === 2)
            this.level3 = temp.filter(x => x.difficulty === 3)
            this.level4 = temp.filter(x => x.difficulty === 4)
            this.level5 = temp.filter(x => x.difficulty === 5)
        },
        async readAll () {
            if (!this.isBusy) {
                this.isBusy = true

                try {
                    const response = await apiService.getMasteries()
                    this.items = response.data

                    this.resolveItems()
                } finally {
                    this.isBusy = false
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
